import { useState } from 'react'

import { useErrorBoundary } from 'react-error-boundary'

import { userFollowUser, userUnfollowUser } from '~/api-client/food_api/user'
import { User } from '~/api-definition/definition'
import { Button } from '~/components/action/Button'
import { Modal } from '~/components/action/Modal'
import {
  ArrowDoubleIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
} from '~/components/icons'
import { useSession } from '~/provider/SessionProvider'

export const UserFollowButton: React.FC<{
  user: User
  showFollowingStatusSymbol?: boolean
  onChangeFollowingStatus: () => Promise<void>
}> = (props) => {
  const session = useSession()
  const accessToken = session.response?.data.accessToken
  const { showBoundary } = useErrorBoundary()

  const [isLoading, setIsLoading] = useState(false)

  const [unfollowModal, setUnfollowModal] = useState(false)

  return (
    <>
      <Modal
        isOpen={unfollowModal}
        title={`${props.user.displayName}さんのフォロー解除してもよろしいですか？`}
        actionButtons={
          <div className="grid grid-cols-2 mt-4 gap-x-4">
            <Button
              type="button"
              variant="functionWeak"
              shrink
              onClick={async (e) => {
                e.stopPropagation()

                setUnfollowModal(false)
              }}
            >
              キャンセル
            </Button>
            <Button
              type="button"
              variant="primary"
              shrink
              onClick={async (e) => {
                e.stopPropagation()

                if (isLoading) return
                setIsLoading(true)
                try {
                  if (accessToken) {
                    await userUnfollowUser({
                      accessToken,
                      searchParams: {
                        user_id: props.user.userId,
                      },
                    })
                    await props.onChangeFollowingStatus()
                  }
                } catch (e) {
                  showBoundary(e)
                } finally {
                  setUnfollowModal(false)
                  setIsLoading(false)
                }
              }}
            >
              解除する
            </Button>
          </div>
        }
      />
      <button
        type="button"
        className={`text-xs px-2 py-1 border border-[#E6E6EA] flex items-center space-x-2 rounded-md whitespace-nowrap ${
          !props.user.following && 'bg-gray'
        }`}
        onClick={async (e) => {
          e.preventDefault()
          e.stopPropagation()

          if (isLoading) return

          setIsLoading(true)
          try {
            if (accessToken) {
              if (props.user.following) {
                setUnfollowModal(true)
                setIsLoading(false)
              } else {
                await userFollowUser({
                  accessToken,
                  body: {
                    user_id: props.user.userId,
                  },
                })
                await props.onChangeFollowingStatus()
                setIsLoading(false)
              }
            }
          } catch (e) {
            showBoundary(e)
          }
        }}
      >
        {props.user.following && (
          <>
            {props.showFollowingStatusSymbol ? (
              props.user.followed ? (
                <ArrowDoubleIcon className="mr-1 fill-black" />
              ) : (
                <ArrowRightIcon className="mr-1 fill-black" />
              )
            ) : undefined}

            <span>フォロー中</span>
          </>
        )}
        {!props.user.following && (
          <>
            {props.showFollowingStatusSymbol && props.user.followed && (
              <ArrowLeftIcon className="mr-1 fill-black" />
            )}
            <span>フォローする</span>
          </>
        )}
      </button>
    </>
  )
}
